import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import throttle from 'lodash/throttle';

import {checkIfAllLinksAreQuarantined, groupResourcesLinksByType} from '../organization-configurations/utils';
import * as types from './types';

const syncSiteTypes = (force = false) => {
  return (dispatch, getState, {sites}) => {
    const locale = getState()?.localization?.locale;

    if (force || getState()?.sites?.locale !== locale || isEmpty(getState()?.sites?.list)) {
      dispatch({type: types.SITE_TYPES_REQUEST});

      return sites
        .getSiteTypes({params: {locale}})
        .then((results) =>
          dispatch({
            type: types.SITE_TYPES_SUCCESS,
            payload: {
              list: results?.data?.map((value) => {
                return {
                  label: value.name,
                  value: value.id,
                };
              }),
              locale,
            },
          }),
        )
        .catch((error) =>
          dispatch({
            type: types.SITE_TYPES_FAILURE,
            error,
          }),
        );
    }
  };
};

const _throttledSyncSiteTypes = throttle((dispatch, force) => dispatch(syncSiteTypes(force)), 10000);

export const getSiteTypes = (force) => {
  return (dispatch) => {
    return _throttledSyncSiteTypes(dispatch, force);
  };
};

export const getSiteResources = (orgId, siteId) => {
  return (dispatch, _getState, {resources}) => {
    dispatch({type: types.GET_SITE_RESOURCES_REQUEST});

    return resources
      .getSiteResources(orgId, siteId)
      .then((result) => {
        const groupedLinks = groupResourcesLinksByType(result);
        const allLinksQuarantined =
          !isEmpty(groupedLinks?.links?.DOCUMENT) && checkIfAllLinksAreQuarantined(groupedLinks?.links?.DOCUMENT);
        if (allLinksQuarantined) {
          delete groupedLinks?.links?.DOCUMENT;
        }
        return dispatch({
          type: types.GET_SITE_RESOURCES_SUCCESS,
          payload: {
            data: groupedLinks,
          },
        });
      })
      .catch(() => {
        dispatch({type: types.GET_SITE_RESOURCES_FAILURE});
      });
  };
};

export const getSiteTypesDict = (clientId, force) => {
  return (dispatch, getState, {sites}) => {
    const locale = getState()?.localization?.locale;

    const notInDictionary = isNil(getState()?.sites?.siteTypesDict?.[clientId]?.[locale]);

    if (force || notInDictionary) {
      dispatch({type: types.SITE_TYPES_DICT_REQUEST});

      return sites
        .getSiteTypes({params: {locale, organizationId: clientId}})
        .then((results) => {
          return dispatch({
            type: types.SITE_TYPES_DICT_SUCCESS,
            payload: {
              list: results?.data?.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                  mapIconUrl: item.mapIconUrl,
                  iconUrl: item.iconUrl,
                  iconId: item.iconId,
                };
              }),
              locale,
              clientId,
            },
          });
        })
        .catch((error) =>
          dispatch({
            type: types.SITE_TYPES_DICT_FAILURE,
            error,
          }),
        );
    }

    return Promise.resolve();
  };
};
